module.exports = __webpack_public_path__ + "img/area_banner_bg.cd54da19.png";